<template>
    <b-button
        class="story-collapse-button"
        variant="link"
        href="#story-collapse"
        @click.prevent="scrollToTheStory"
    >
        <lazy-image
            v-if="ourStoryImage"
            :src="ourStoryImage.src"
            :alt="ourStoryImage.alt"
            :width="ourStoryImage.width"
            :height="ourStoryImage.height"
        />

        <template v-else>
            <lazy-image
                class="motion-disabled-image"
                src="../../../../resources/assets/images/svgs/butterfly-story.svg"
                alt=""
                :width="154"
                :height="100"
            />
            <lottie-animation
                v-if="animationData"
                class="lottie"
                :animation-data="animationData"
                loop
            />
        </template>
        <span class="sr-only">
            {{ $snippet('the_story', 'the story') }}
        </span>
    </b-button>
</template>

<script>
    import VueSetTimeout from '@netsells/vue-set-timeout';
    import itsuStoryBus from '../../../lib/itsu-story-bus';

    //eslint-disable-next-line @netsells/require-jsdoc-except/require-jsdoc
    const LottieAnimation = () => import('lottie-web-vue');

    export default {
        name: 'story-collapse-button',

        components: { LottieAnimation },

        mixins: [VueSetTimeout],

        props: {
            productType: {
                type: String,
                required: true,
            },
        },

        data() {
            return {
                animationData: null,
            };
        },

        computed: {
            /**
             * Return the image override for the "our story" button.
             *
             * @returns {object}
             */
            ourStoryImage() {
                return this.$snippet(`our_story_${ this.productType }_image`);
            },
        },

        mounted() {
            if (this.ourStoryImage) {
                return;
            }

            // Only load the svg if we don't have an image provided
            this.loadSvg();
        },

        methods: {
            /**
             * Load the lottie animation file asynchronously.
             */
            async loadSvg() {
                const { default: svg } = await import('../../../lib/lottie-butterfly');

                this.animationData = svg;
            },

            /**
             * Open the story and scroll/focus to it.
             */
            scrollToTheStory() {
                itsuStoryBus.$emit('open');

                const el = document.getElementById('story-collapse');

                if (!el) {
                    return;
                }

                this.setTimeout(() => {
                    el.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                    });

                    el.setAttribute('tabIndex', '-1');

                    el.focus({ preventScroll: true });
                }, 300);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .story-collapse-button {
        border-radius: 15px;

        &:hover,
        &:focus-visible,
        &:active {
            outline: 1px solid $itsu-primary;
            outline-offset: 5px;
        }
    }

    .lazy-image {
        width: 100%;
        height: auto;
        display: block;
    }

    .motion-disabled-image {
        @include transitions-enabled {
            display: none;
        }
    }

    .lottie {
        display: none;
        @include transitions-enabled {
            display: block;
        }
    }
</style>
